import { createEmptyAction } from "chalet-shared";

export const actionCreators = {
    onIdle: createEmptyAction("ON_IDLE"),
    onActive: createEmptyAction("ON_ACTIVE"),
};
